// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-container {
  width: 100%;
}
/* toolbar */
.calendar-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}
.calendar-toolbar h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.01em;
  text-transform: capitalize;
  color: #0f172a;
}
.cal-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.cal-nav {
  display: inline-flex;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 7px;
  overflow: hidden;
}
.cal-btn {
  height: 38px;
  padding: 0 14px;
  border: 0;
  background: #ffffff;
  color: #334155;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.12s;
}
.cal-btn + .cal-btn {
  border-left: 1px solid #e5e7eb;
}
.cal-btn:hover {
  background: #f1f5f9;
}
.cal-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-bottom: 10px;
  font-size: 12px;
  color: #64748b;
}
.cal-legend span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.cal-legend i {
  display: inline-block;
  width: 16px;
  height: 10px;
  border-radius: 2px;
}
.cal-legend .in i {
  background: #0f766e;
}
.cal-legend .out i {
  background: #f59e0b;
}
.cal-legend .full i {
  background: #14b8a6;
}
/* grid */
.calendar-main-wrapper {
  position: relative;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);
}
.calendar-grid {
  display: none;
}
.truncate {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.room-names-column {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 170px;
  z-index: 2;
  background: #ffffff;
  border-right: 1px solid #e5e7eb;
  box-shadow: 6px 0 10px -8px rgba(15, 23, 42, 0.3);
}
.room-names-column .room-name-main {
  height: 64px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.room-names-column .calendar-room {
  height: 48px;
  border-bottom: 1px solid #eef0f3;
}
.room-names-column .room-name {
  height: 48px;
  line-height: 48px;
  padding: 0 14px;
}
.room-names-column .room-name h3 {
  margin: 0;
  padding: 0;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
}
.calendar-content {
  padding-left: 170px;
  overflow-x: auto;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  -webkit-overflow-scrolling: touch;
}
.calendar-content:active {
  cursor: grabbing;
}
.calendar-content .days-grid {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(44px, 1fr);
  width: 100%;
}
.calendar-content .calendar-row-top {
  height: 64px;
  border-bottom: 1px solid #e5e7eb;
}
.calendar-content .calendar-row {
  height: 48px;
  border-bottom: 1px solid #eef0f3;
}
.calendar-content .calendar-row:hover .day-cell:not(.today) {
  background: #f8fafc;
}
/* day header */
.day-cell-top {
  background: #f9fafb;
  border-right: 1px solid #eef0f3;
}
.day-cell-top .day-header {
  height: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.day-cell-top .day-header p {
  margin: 0;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #94a3b8;
}
.day-cell-top .day-header h3 {
  margin: 2px 0 0;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}
.day-cell-top.weekend .day-header h3 {
  color: #94a3b8;
}
.day-cell-top.today {
  background: #0f766e;
}
.day-cell-top.today .day-header p {
  color: #99f6e4;
}
.day-cell-top.today .day-header h3 {
  color: #ffffff;
}
/* day cell */
.day-cell {
  height: 48px;
  border-right: 1px solid #eef0f3;
}
.day-cell.weekend {
  background: #fafafa;
}
.day-cell.today {
  background: #f0fdfa;
}
.day-cell .day {
  height: 100%;
  display: flex;
  align-items: center;
}
.day-cell .day i {
  font-size: 11px;
}
.day-cell .full-day,
.day-cell .check-in,
.day-cell .check-out {
  height: 28px;
  cursor: pointer;
  transition: filter 0.12s;
}
.day-cell .full-day:hover,
.day-cell .check-in:hover,
.day-cell .check-out:hover {
  filter: brightness(1.1);
}
.day-cell .full-day {
  width: 100%;
  background: #14b8a6;
}
.day-cell .check-in,
.day-cell .check-out {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}
.day-cell .check-out {
  order: 1;
  background: #f59e0b;
  border-radius: 0 4px 4px 0;
}
.day-cell .check-in {
  order: 2;
  margin-left: auto;
  background: #0f766e;
  border-radius: 4px 0 0 4px;
}
@media (max-width: 600px) {
  .room-names-column {
    width: 110px;
  }
  .calendar-content {
    padding-left: 110px;
  }
}
/*# sourceMappingURL=calendar.component.css.map */`, "",{"version":3,"sources":["webpack://./calendar.component.less","webpack://./src/app/components/calendar/calendar.component.less"],"names":[],"mappings":"AAQA;EACE,WAAA;ACPF;AACA,YAAY;ADUZ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;ACRF;ADEA;EASI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;EACA,cAAA;ACRJ;ADYA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;ACVF;ADaA;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;ACXF;ADcA;EACE,YAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;ACZF;ADcE;EACE,8BAAA;ACZJ;ADeE;EACE,mBAAA;ACbJ;ADiBA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;ACfF;ADSA;EASI,oBAAA;EACA,mBAAA;EACA,QAAA;ACfJ;ADIA;EAeI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AChBJ;ADFA;EAqBU,mBAAA;AChBV;ADLA;EAsBW,mBAAA;ACdX;ADRA;EAuBY,mBAAA;ACZZ;AACA,SAAS;ADeT;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mDAAA;ACbF;ADgBA;EACE,aAAA;ACdF;ADiBA;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;ACfF;ADkBA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,+BAAA;EACA,iDAAA;AChBF;ADOA;EAYI,YAAA;EACA,mBAAA;EACA,gCAAA;AChBJ;ADEA;EAkBI,YAAA;EACA,gCAAA;ACjBJ;ADFA;EAuBI,YAAA;EACA,iBAAA;EACA,eAAA;AClBJ;ADPA;EA4BM,SAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AClBN;ADuBA;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;EACA,iCAAA;ACrBF;ADuBE;EACE,gBAAA;ACrBJ;ADaA;EAYI,aAAA;EACA,sBAAA;EACA,oCAAA;EACA,WAAA;ACtBJ;ADOA;EAmBI,YAAA;EACA,gCAAA;ACvBJ;ADGA;EAwBI,YAAA;EACA,gCAAA;ACxBJ;AD0BI;EACE,mBAAA;ACxBN;AACA,eAAe;AD6Bf;EACE,mBAAA;EACA,+BAAA;AC3BF;ADyBA;EAKI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AC3BJ;ADkBA;EAYM,SAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AC3BN;ADWA;EAoBM,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AC5BN;ADgCE;EACE,cAAA;AC9BJ;ADiCE;EACE,mBAAA;AC/BJ;AD8BE;EAII,cAAA;AC/BN;AD2BE;EAQI,cAAA;AChCN;AACA,aAAa;ADqCb;EACE,YAAA;EACA,+BAAA;ACnCF;ADqCE;EACE,mBAAA;ACnCJ;ADsCE;EACE,mBAAA;ACpCJ;AD2BA;EAaI,YAAA;EACA,aAAA;EACA,mBAAA;ACrCJ;ADsBA;EAkBM,eAAA;ACrCN;ADmBA;;;EAyBI,YAAA;EACA,eAAA;EACA,wBAAA;ACvCJ;ADyCI;;;EACE,uBAAA;ACrCN;ADOA;EAmCI,WAAA;EACA,mBAAA;ACvCJ;ADGA;;EAyCI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;ACxCJ;ADLA;EAiDI,QAAA;EACA,mBAAA;EACA,0BAAA;ACzCJ;ADVA;EAuDI,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,0BAAA;AC1CJ;AD8CA;EAEE;IACE,YAAA;EC7CF;EDgDA;IACE,mBAAA;EC9CF;AACF;AACA,iDAAiD","sourcesContent":["@import (reference) \"../../../assets/less/colors.less\";\n\n@names: 170px;\n@head: 64px;\n@row: 48px;\n@line: #eef0f3;\n@bar: 28px;\n\n.calendar-container {\n  width: 100%;\n}\n\n/* toolbar */\n.calendar-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 12px;\n\n  h2 {\n    margin: 0;\n    font-size: 22px;\n    font-weight: 700;\n    letter-spacing: -0.01em;\n    text-transform: capitalize;\n    color: #0f172a;\n  }\n}\n\n.cal-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.cal-nav {\n  display: inline-flex;\n  background: @white;\n  border: 1px solid #e5e7eb;\n  border-radius: @radius;\n  overflow: hidden;\n}\n\n.cal-btn {\n  height: 38px;\n  padding: 0 14px;\n  border: 0;\n  background: @white;\n  color: #334155;\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.12s;\n\n  & + & {\n    border-left: 1px solid #e5e7eb;\n  }\n\n  &:hover {\n    background: #f1f5f9;\n  }\n}\n\n.cal-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 18px;\n  margin-bottom: 10px;\n  font-size: 12px;\n  color: #64748b;\n\n  span {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  i {\n    display: inline-block;\n    width: 16px;\n    height: 10px;\n    border-radius: 2px;\n  }\n\n  .in i { background: #0f766e; }\n  .out i { background: #f59e0b; }\n  .full i { background: #14b8a6; }\n}\n\n/* grid */\n.calendar-main-wrapper {\n  position: relative;\n  overflow: hidden;\n  background: @white;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);\n}\n\n.calendar-grid {\n  display: none;\n}\n\n.truncate {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.room-names-column {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: @names;\n  z-index: 2;\n  background: @white;\n  border-right: 1px solid #e5e7eb;\n  box-shadow: 6px 0 10px -8px rgba(15, 23, 42, 0.3);\n\n  .room-name-main {\n    height: @head;\n    background: #f9fafb;\n    border-bottom: 1px solid #e5e7eb;\n  }\n\n  .calendar-room {\n    height: @row;\n    border-bottom: 1px solid @line;\n  }\n\n  .room-name {\n    height: @row;\n    line-height: @row;\n    padding: 0 14px;\n\n    h3 {\n      margin: 0;\n      padding: 0;\n      font-size: 13px;\n      font-weight: 600;\n      color: #0f172a;\n    }\n  }\n}\n\n.calendar-content {\n  padding-left: @names;\n  overflow-x: auto;\n  cursor: grab;\n  user-select: none;\n  -webkit-overflow-scrolling: touch;\n\n  &:active {\n    cursor: grabbing;\n  }\n\n  .days-grid {\n    display: grid;\n    grid-auto-flow: column;\n    grid-auto-columns: minmax(44px, 1fr);\n    width: 100%;\n  }\n\n  .calendar-row-top {\n    height: @head;\n    border-bottom: 1px solid #e5e7eb;\n  }\n\n  .calendar-row {\n    height: @row;\n    border-bottom: 1px solid @line;\n\n    &:hover .day-cell:not(.today) {\n      background: #f8fafc;\n    }\n  }\n}\n\n/* day header */\n.day-cell-top {\n  background: #f9fafb;\n  border-right: 1px solid @line;\n\n  .day-header {\n    height: @head;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    p {\n      margin: 0;\n      font-size: 11px;\n      text-transform: uppercase;\n      letter-spacing: 0.05em;\n      color: #94a3b8;\n    }\n\n    h3 {\n      margin: 2px 0 0;\n      font-size: 16px;\n      font-weight: 700;\n      color: #0f172a;\n    }\n  }\n\n  &.weekend .day-header h3 {\n    color: #94a3b8;\n  }\n\n  &.today {\n    background: #0f766e;\n\n    .day-header p {\n      color: #99f6e4;\n    }\n\n    .day-header h3 {\n      color: @white;\n    }\n  }\n}\n\n/* day cell */\n.day-cell {\n  height: @row;\n  border-right: 1px solid @line;\n\n  &.weekend {\n    background: #fafafa;\n  }\n\n  &.today {\n    background: #f0fdfa;\n  }\n\n  .day {\n    height: 100%;\n    display: flex;\n    align-items: center;\n\n    i {\n      font-size: 11px;\n    }\n  }\n\n  .full-day,\n  .check-in,\n  .check-out {\n    height: @bar;\n    cursor: pointer;\n    transition: filter 0.12s;\n\n    &:hover {\n      filter: brightness(1.1);\n    }\n  }\n\n  .full-day {\n    width: 100%;\n    background: #14b8a6;\n  }\n\n  .check-in,\n  .check-out {\n    width: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: @white;\n  }\n\n  .check-out {\n    order: 1;\n    background: #f59e0b;\n    border-radius: 0 4px 4px 0;\n  }\n\n  .check-in {\n    order: 2;\n    margin-left: auto;\n    background: #0f766e;\n    border-radius: 4px 0 0 4px;\n  }\n}\n\n@media (max-width: 600px) {\n\n  .room-names-column {\n    width: 110px;\n  }\n\n  .calendar-content {\n    padding-left: 110px;\n  }\n}\n",".calendar-container {\n  width: 100%;\n}\n/* toolbar */\n.calendar-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n.calendar-toolbar h2 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  text-transform: capitalize;\n  color: #0f172a;\n}\n.cal-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n.cal-nav {\n  display: inline-flex;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 7px;\n  overflow: hidden;\n}\n.cal-btn {\n  height: 38px;\n  padding: 0 14px;\n  border: 0;\n  background: #ffffff;\n  color: #334155;\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.12s;\n}\n.cal-btn + .cal-btn {\n  border-left: 1px solid #e5e7eb;\n}\n.cal-btn:hover {\n  background: #f1f5f9;\n}\n.cal-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 18px;\n  margin-bottom: 10px;\n  font-size: 12px;\n  color: #64748b;\n}\n.cal-legend span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.cal-legend i {\n  display: inline-block;\n  width: 16px;\n  height: 10px;\n  border-radius: 2px;\n}\n.cal-legend .in i {\n  background: #0f766e;\n}\n.cal-legend .out i {\n  background: #f59e0b;\n}\n.cal-legend .full i {\n  background: #14b8a6;\n}\n/* grid */\n.calendar-main-wrapper {\n  position: relative;\n  overflow: hidden;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);\n}\n.calendar-grid {\n  display: none;\n}\n.truncate {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.room-names-column {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 170px;\n  z-index: 2;\n  background: #ffffff;\n  border-right: 1px solid #e5e7eb;\n  box-shadow: 6px 0 10px -8px rgba(15, 23, 42, 0.3);\n}\n.room-names-column .room-name-main {\n  height: 64px;\n  background: #f9fafb;\n  border-bottom: 1px solid #e5e7eb;\n}\n.room-names-column .calendar-room {\n  height: 48px;\n  border-bottom: 1px solid #eef0f3;\n}\n.room-names-column .room-name {\n  height: 48px;\n  line-height: 48px;\n  padding: 0 14px;\n}\n.room-names-column .room-name h3 {\n  margin: 0;\n  padding: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #0f172a;\n}\n.calendar-content {\n  padding-left: 170px;\n  overflow-x: auto;\n  cursor: grab;\n  user-select: none;\n  -webkit-overflow-scrolling: touch;\n}\n.calendar-content:active {\n  cursor: grabbing;\n}\n.calendar-content .days-grid {\n  display: grid;\n  grid-auto-flow: column;\n  grid-auto-columns: minmax(44px, 1fr);\n  width: 100%;\n}\n.calendar-content .calendar-row-top {\n  height: 64px;\n  border-bottom: 1px solid #e5e7eb;\n}\n.calendar-content .calendar-row {\n  height: 48px;\n  border-bottom: 1px solid #eef0f3;\n}\n.calendar-content .calendar-row:hover .day-cell:not(.today) {\n  background: #f8fafc;\n}\n/* day header */\n.day-cell-top {\n  background: #f9fafb;\n  border-right: 1px solid #eef0f3;\n}\n.day-cell-top .day-header {\n  height: 64px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.day-cell-top .day-header p {\n  margin: 0;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #94a3b8;\n}\n.day-cell-top .day-header h3 {\n  margin: 2px 0 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n}\n.day-cell-top.weekend .day-header h3 {\n  color: #94a3b8;\n}\n.day-cell-top.today {\n  background: #0f766e;\n}\n.day-cell-top.today .day-header p {\n  color: #99f6e4;\n}\n.day-cell-top.today .day-header h3 {\n  color: #ffffff;\n}\n/* day cell */\n.day-cell {\n  height: 48px;\n  border-right: 1px solid #eef0f3;\n}\n.day-cell.weekend {\n  background: #fafafa;\n}\n.day-cell.today {\n  background: #f0fdfa;\n}\n.day-cell .day {\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n.day-cell .day i {\n  font-size: 11px;\n}\n.day-cell .full-day,\n.day-cell .check-in,\n.day-cell .check-out {\n  height: 28px;\n  cursor: pointer;\n  transition: filter 0.12s;\n}\n.day-cell .full-day:hover,\n.day-cell .check-in:hover,\n.day-cell .check-out:hover {\n  filter: brightness(1.1);\n}\n.day-cell .full-day {\n  width: 100%;\n  background: #14b8a6;\n}\n.day-cell .check-in,\n.day-cell .check-out {\n  width: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n}\n.day-cell .check-out {\n  order: 1;\n  background: #f59e0b;\n  border-radius: 0 4px 4px 0;\n}\n.day-cell .check-in {\n  order: 2;\n  margin-left: auto;\n  background: #0f766e;\n  border-radius: 4px 0 0 4px;\n}\n@media (max-width: 600px) {\n  .room-names-column {\n    width: 110px;\n  }\n  .calendar-content {\n    padding-left: 110px;\n  }\n}\n/*# sourceMappingURL=calendar.component.css.map */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
